
import React from 'react'
import PropTypes from 'prop-types'
export const ModalContext = React.createContext({})

export default class ModalContextProvider extends React.Component {
  _showModal = (component, props) => {
    console.log('should toggle a modal')
    this.setState({
      visible: true,
      component,
      props
    })
  }

  _onClose = () => {
    this.setState({
      visible: false,
      component: null,
      props: {}
    })
  }

  state = {
    visible: true,
    component: null,
    props: {},
    showModal: this._showModal,
    hideModal: this._onClose
  };

  render () {
    const { children } = this.props
    return (
      <ModalContext.Provider value={this.state}>
        {children}
      </ModalContext.Provider>
    )
  }
}

ModalContextProvider.propTypes = {
  children: PropTypes.any
}

export const ModalConsumer = ModalContext.Consumer
